module.exports = __webpack_public_path__ + "media/organizations/udk-berlin-b4a75a78.svg";